import {
  CustomFormatDateOptions,
  CustomFormatDateTimeOptions,
  DateDisplay,
  DateTimeDisplay,
  DateDisplayInput,
  DateTimeDisplayInput
} from '~/design_system'

export type TimestampProps =
  | {
      showDateOnly?: false
      datetime: DateTimeDisplayInput
      showTimezone?: boolean
      timezone?: string
      formatOptions?: CustomFormatDateTimeOptions
    }
  | {
      showDateOnly: true
      datetime: DateDisplayInput
      showTimezone?: never
      timezone?: never
      formatOptions?: CustomFormatDateOptions
    }

/**
 * @deprecated Use DateString or DateTimeString instead
 */
export const Timestamp = (props: TimestampProps) => {
  return props.showDateOnly ? (
    <DateDisplay input={props.datetime} timeZone={props.timezone} {...props.formatOptions} />
  ) : (
    <DateTimeDisplay
      input={props.datetime}
      timeZone={props.timezone}
      timeZoneName={props.showTimezone}
      {...props.formatOptions}
    />
  )
}
